import { FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';

type ValueUpPlanSignificanceFormFieldsProps = {
  planIndex: number;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const ValueUpPlanSignificanceFormFields = (
  props: ValueUpPlanSignificanceFormFieldsProps
) => {
  const { planIndex, isCompletedTh = false, isCompletedEn = false } = props;

  return (
    <>
      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.significanceTh`}
        label="ที่มา และความสำคัญ (ไทย)"
        required
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (ไทย)',
        }}
        sx={
          isCompletedTh
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />

      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.significanceEn`}
        label="ที่มา และความสำคัญ (อังกฤษ)"
        required
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (อังกฤษ)',
        }}
        sx={
          isCompletedEn
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />
    </>
  );
};

export default ValueUpPlanSignificanceFormFields;
